import request from '@/utils/request'


// 获取系统信息
export function GetSysinfo() {
  return request({
      url: '/Notes/sysinfo',
      method: 'get'
  })
}


// 获取8张logo
export function Get8logo() {
  return request({
      url: '/Notes/logo',
      method: 'get'
  })
}


// 根据type获取tab
export function GetTabgrade(params) {
  return request({
      url: '/Notes/tabgrade',
      method: 'get',
      params
  })
}

// 获取item数据
export function GetItem(data) {
  return request({
      url: '/Notes/item',
      method: 'post',
      data
  })
}

// 上报点击item
export function Onclick(id) {
  return request({
      url: '/Notes/onclick/' + id,
      method: 'get'
  })
}

// 获取榜单数据
export function GetCharts() {
  return request({
      url: '/Notes/charts',
      method: 'get'
  })
}

// 获取热门搜索词
export function GetHopkey() {
  return request({
      url: '/Notes/hopkey',
      method: 'get'
  })
}

// 提交建议
export function AddRecommendation(data) {
  return request({
      url: '/Notes/recommendation',
      method: 'post',
      data
  })
}

// 获取总资源数
export function GetItemtotal() {
  return request({
      url: '/Notes/itemtotal',
      method: 'get'
  })
}

